import { gql } from "@apollo/client";

export const SECURITY_KEY_DELETE = gql`
  mutation SecurityKeyDelete($id: ID!) {
    securityKeyDelete(id: $id) {
      id
    }
  }
`;
